export const DEFAULT_VIDEO_WIDTH = 500;
export const DEFAULT_VIDEO_HEIGHT = 281;
